import updateDocumentData from "../../utils/updateDocumentData";

import { User } from "./types/User";

export default function updateUser(firebase, ref, data) {
	return ref.set(User.partial().parse(updateDocumentData(firebase, data)), { merge: true });
}
